module.exports = __webpack_public_path__ + "img/product_0_4.08c61ea8.jpg";